import FormUIOptions from '../../components/formBuilder/formElements/formUIOptions';
import defaults from '../../constants/investmentCriteria';

export const purchaseCriteria = {
  sectionLabel: 'Purchase',
  sectionDescription:
    'Set your investment criteria for properties on purchase.',
  sectionValue: 'purchaseCriteria',
  sectionCollapsed: true,
  sectionDescription: '',
  sectionClasses: '',
  schema: [
    {
      type: FormUIOptions.Toggle,
      label: 'Purchase Price',
      name: 'screenPurchasePrice',
      description: 'Set a maximum allowable purchase price',
      defaultValue: defaults.screenPurchasePrice,
    },
    {
      type: FormUIOptions.Money,
      label: 'Max Purchase Price',
      name: 'maxPurchasePrice',
      defaultValue: defaults.maxPurchasePrice,
      condition: {
        field: 'screenPurchasePrice',
        isLocal: true,
        value: true,
      },
    },
    {
      type: FormUIOptions.Toggle,
      label: 'Cash Needed',
      description:
        'Set a maximum allowable cash needed (downpayment + closing costs)',
      name: 'screenCashNeededPurchase',
      defaultValue: defaults.screenCashNeededPurchase,
    },
    {
      type: FormUIOptions.UnitMoney,
      selectOptions: FormUIOptions.selectOptions.percentage,
      label: 'Max Cash Needed',
      description: 'Enter an amount or percentage of the purchase price',
      name: 'cashNeededPurchaseCriteria',
      derivedFrom: 'purchasePrice',
      defaultValue: defaults.cashNeededPurchaseCriteria,
      condition: {
        field: 'screenCashNeededPurchase',
        isLocal: true,
        value: true,
      },
    },
    {
      type: FormUIOptions.Toggle,
      label: '1% Rule',
      description:
        'The monthly gross rent should be at least 1% of the purchase price',
      name: 'screenOnePercentRulePurchase',
      defaultValue: defaults.screenOnePercentRulePurchase,
    },
    {
      type: FormUIOptions.Toggle,
      label: '50% Rule',
      description:
        'The monthly expenses should be less than or equal to 50% of the monthly gross rent',
      name: 'screenFiftyPercentRulePurchase',
      defaultValue: defaults.screenFiftyPercentRulePurchase,
    },
    {
      type: FormUIOptions.Toggle,
      label: 'Cash Flow',
      name: 'screenCashFlowPurchase',
      description: 'Set a minimum allowable cash flow',
      defaultValue: defaults.screenCashFlowPurchase,
    },
    {
      type: FormUIOptions.Money,
      label: 'Min Cash Flow (Monthly)',
      name: 'minCashFlowPurchase',
      defaultValue: defaults.minCashFlowPurchase,
      condition: {
        field: 'screenCashFlowPurchase',
        isLocal: true,
        value: true,
      },
    },
    {
      type: FormUIOptions.Toggle,
      label: 'Cap Rate (Purchase Price)',
      name: 'screenCapRatePurchase',
      description: 'Set a minimum allowable cap rate',
      defaultValue: defaults.screenCapRatePurchase,
    },
    {
      type: FormUIOptions.Number,
      label: 'Min Cap Rate',
      unit: '%',
      name: 'minCapRatePurchase',
      defaultValue: defaults.minCapRatePurchase,
      condition: {
        field: 'screenCapRatePurchase',
        isLocal: true,
        value: true,
      },
    },

    {
      type: FormUIOptions.Toggle,
      label: 'Total ROI Year 1',
      description: 'Set a minimum allowable total ROI year 1',
      name: 'screenTotalRoiYear1Purchase',
      defaultValue: defaults.screenTotalRoiYear1Purchase,
    },
    {
      type: FormUIOptions.Number,
      unit: '%',
      label: 'Min Total ROI Year 1',
      name: 'minTotalRoiYear1Purchase',
      defaultValue: defaults.minTotalRoiYear1Purchase,
      condition: {
        field: 'screenTotalRoiYear1Purchase',
        isLocal: true,
        value: true,
      },
    },
  ],
};

export const buyAndHoldCriteria = {
  sectionLabel: 'Buy and Hold (After Rehab)',
  sectionDescrption:
    'Set your investment criteria for the rehab / buy and hold analysis.',
  sectionValue: 'buyAndHold',
  sectionCollapsed: true,
  sectionDescription: '',
  sectionClasses: '',
  schema: [
    {
      type: FormUIOptions.Toggle,
      label: '70% Rule',
      description:
        'The purchase price should be less than or equal to 70% of the ARV, minus the rehab costs',
      name: 'screenSeventyPercentRuleBuyAndHold',
      defaultValue: defaults.screenSeventyPercentRuleBuyAndHold,
    },
    {
      type: FormUIOptions.Toggle,
      label: 'Total Profit',
      description:
        'Compare the total profit to the total profit on the purchase (equity + cash flow - cash needed)',
      name: 'screenTotalProfitBuyAndHold',
      defaultValue: defaults.screenTotalProfitBuyAndHold,
    },
    {
      type: FormUIOptions.Money,
      unit: '$',
      name: 'totalProfitBuyAndHold',
      label: 'Min Increase',
      defaultValue: defaults.totalProfitBuyAndHold,
      condition: {
        field: 'screenTotalProfitBuyAndHold',
        isLocal: true,
        value: true,
      },
    },
    {
      type: FormUIOptions.Toggle,
      label: 'Cash Needed',
      description:
        'Set a maximum allowable cash needed (downpayment + closing costs)',
      name: 'screenCashNeededBuyAndHold',
      defaultValue: defaults.screenCashNeededBuyAndHold,
    },
    {
      type: FormUIOptions.UnitMoney,
      selectOptions: FormUIOptions.selectOptions.percentage,
      label: 'Max Cash Needed',
      description: 'Enter an amount or percentage of the purchase price',
      name: 'cashNeededBuyAndHoldCriteria',
      derivedFrom: 'purchasePrice',
      defaultValue: defaults.cashNeededBuyAndHoldCriteria,
      condition: {
        field: 'screenCashNeededPurchase',
        isLocal: true,
        value: true,
      },
    },
    {
      type: FormUIOptions.Toggle,
      label: '1% Rule',
      description:
        'The monthly gross rent should be at least 1% of the purchase price',
      name: 'screenOnePercentRuleBuyAndHold',
      defaultValue: defaults.screenOnePercentRuleBuyAndHold,
    },
    {
      type: FormUIOptions.Toggle,
      label: '50% Rule',
      description:
        'The monthly expenses should be less than or equal to 50% of the monthly gross rent',
      name: 'screenFiftyPercentRuleBuyAndHold',
      defaultValue: defaults.screenFiftyPercentRuleBuyAndHold,
    },
    {
      type: FormUIOptions.Toggle,
      label: 'Cash Flow',
      name: 'screenCashFlowBuyAndHold',
      description: 'Set a minimum allowable cash flow',
      defaultValue: defaults.screenCashFlowBuyAndHold,
    },
    {
      type: FormUIOptions.Money,
      label: 'Min Cash Flow (Monthly)',
      name: 'minCashFlowBuyAndHold',
      defaultValue: defaults.minCashFlowBuyAndHold,
      condition: {
        field: 'screenCashFlowBuyAndHold',
        isLocal: true,
        value: true,
      },
    },
    {
      type: FormUIOptions.Toggle,
      label: 'Cap Rate (Purchase Price)',
      name: 'screenCapRateBuyAndHold',
      description: 'Set a minimum allowable cap rate',
      defaultValue: defaults.screenCapRateBuyAndHold,
    },
    {
      type: FormUIOptions.Number,
      label: 'Min Cap Rate',
      name: 'minCapRateBuyAndHold',
      unit: '%',
      defaultValue: defaults.minCapRateBuyAndHold,
      condition: {
        field: 'screenCapRateBuyAndHold',
        isLocal: true,
        value: true,
      },
    },

    {
      type: FormUIOptions.Toggle,
      label: 'Total ROI Year 1',
      description: 'Set a minimum allowable total ROI year 1',
      name: 'screenTotalRoiYear1BuyAndHold',
      defaultValue: defaults.screenTotalRoiYear1BuyAndHold,
    },
    {
      type: FormUIOptions.Number,
      unit: '%',
      label: 'Min Total ROI Year 1',
      name: 'minTotalRoiYear1BuyAndHold',
      defaultValue: defaults.minTotalRoiYear1BuyAndHold,
      condition: {
        field: 'screenTotalRoiYear1BuyAndHold',
        isLocal: true,
        value: true,
      },
    },
  ],
};

export const brrrrCriteria = {
  sectionLabel: 'BRRRR Scenario',
  sectionDescription: 'Set your investment criteria for the BRRRR strategy.',
  sectionValue: 'brrrr',
  sectionCollapsed: true,
  sectionDescription: '',
  sectionClasses: '',
  schema: [
    {
      type: FormUIOptions.Toggle,
      label: '70% Rule',
      description:
        'The purchase price should be less than or equal to 70% of the ARV, minus the rehab costs',
      name: 'screenSeventyPercentRuleBRRRR',
      defaultValue: defaults.screenSeventyPercentRuleBRRRR,
    },
    {
      type: FormUIOptions.Toggle,
      label: 'Total Profit',
      description:
        'Compare the total profit to the total profit on the purchase (equity + cash flow - cash needed)',
      name: 'screenTotalProfitBRRRR',
      defaultValue: defaults.screenTotalProfitBRRRR,
    },
    {
      type: FormUIOptions.Money,
      unit: '$',
      name: 'totalProfitBRRRR',
      label: 'Min Increase',
      defaultValue: defaults.totalProfitBRRRR,
      condition: {
        field: 'screenTotalProfitBRRRR',
        isLocal: true,
        value: true,
      },
    },
    {
      type: FormUIOptions.Toggle,
      label: 'Cash In / Cash Out',
      description: 'Set a requirement for cash in / cash out after the rehab',
      name: 'screenCashNeededBRRRR',
      defaultValue: defaults.screenCashNeededBRRRR,
    },
    {
      type: FormUIOptions.YesNo,
      label: 'Recover Initial Investment?',
      description:
        'Whether the cash out should recover the initial downpayment and closing costs',
      name: 'cashOutInitialInvestmentBRRRR',
      defaultValue: defaults.cashOutInitialInvestmentBRRRR,
      condition: {
        field: 'screenCashNeededBRRRR',
        isLocal: true,
        value: true,
      },
    },
    {
      type: FormUIOptions.YesNo,
      label: 'Recover Rehab Costs?',
      description:
        'Whether the cash out should recover the rehab and refinance costs',
      name: 'cashOutRehabRefinanceBRRRR',
      defaultValue: defaults.cashOutRehabRefinanceBRRRR,
      condition: {
        field: 'screenCashNeededBRRRR',
        isLocal: true,
        value: true,
      },
    },
    {
      type: FormUIOptions.Toggle,
      label: '1% Rule',
      description:
        'The monthly gross rent should be at least 1% of the purchase price',
      name: 'screenOnePercentRuleBRRRR',
      defaultValue: defaults.screenOnePercentRuleBRRRR,
    },
    {
      type: FormUIOptions.Toggle,
      label: '50% Rule',
      description:
        'The monthly expenses should be less than or equal to 50% of the monthly gross rent',
      name: 'screenFiftyPercentRuleBRRRR',
      defaultValue: defaults.screenFiftyPercentRuleBRRRR,
    },
    {
      type: FormUIOptions.Toggle,
      label: 'Cash Flow',
      name: 'screenCashFlowBRRRR',
      description: 'Set a minimum allowable cash flow',
      defaultValue: defaults.screenCashFlowBRRRR,
    },
    {
      type: FormUIOptions.Money,
      label: 'Min Cash Flow',
      name: 'minCashFlowBRRRR',
      defaultValue: defaults.minCashFlowBRRRR,
      condition: {
        field: 'screenCashFlowBRRRR',
        isLocal: true,
        value: true,
      },
    },
    {
      type: FormUIOptions.Toggle,
      label: 'Cap Rate (Purchase Price)',
      name: 'screenCapRateBRRRR',
      description: 'Set a minimum allowable cap rate',
      defaultValue: defaults.screenCapRateBRRRR,
    },
    {
      type: FormUIOptions.Number,
      label: 'Min Cap Rate',
      name: 'minCapRateBRRRR',
      defaultValue: defaults.minCapRateBRRRR,
      unit: '%',
      condition: {
        field: 'screenCapRateBRRRR',
        isLocal: true,
        value: true,
      },
    },

    {
      type: FormUIOptions.Toggle,
      label: 'Total ROI Year 1',
      description: 'Set a minimum allowable total ROI year 1',
      name: 'screenTotalRoiYear1BRRRR',
      defaultValue: defaults.screenTotalRoiYear1BRRRR,
    },
    {
      type: FormUIOptions.Number,
      unit: '%',
      label: 'Min Total ROI Year 1',
      name: 'minTotalRoiYear1BRRRR',
      defaultValue: defaults.minTotalRoiYear1BRRRR,
      condition: {
        field: 'screenTotalRoiYear1BRRRR',
        isLocal: true,
        value: true,
      },
    },
  ],
};
